import { buildSelector } from '@/shared/lib/store';

export const [useSelectedPattern] = buildSelector(
    (state) => state.pattern?.selectedPattern ?? null,
);
